import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { Panel } from '../../Panel/Panel';
import { LoadInfoRow } from '../LoadInfoRow/LoadInfoRow';
import { useStyles } from '../useStyles';

function FlightCardLoadInfo({ legs }) {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <Panel title={translate('flightPage.loadInfo')} className="flight-info__panel  flight-info__panel--preliminary">
            <div className="flight-info__inner">
                <table className="flight-info__table">
                    <thead>
                        <tr>
                            <th className={classnames(classes.columnMain, classes.tableHeaderCell)}>{translate('flightPage.route')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.bcl')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.adt')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.chd')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.inf')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.baggage')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.mail')}</th>
                            <th className={classnames(classes.column, classes.tableHeaderCell)}>{translate('flightPage.cargo')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {legs.map((data) => (
                            <LoadInfoRow key={data.key} item={data.item} />
                        ))}
                    </tbody>
                </table>
            </div>
        </Panel>
    );
}

export { FlightCardLoadInfo };
